import React from 'react';
import { Menu, LogOut, Moon, Sun } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { useTheme } from '../../hooks/useTheme';

const Navbar = ({ onLogout, toggleSidebar, currentPortal, portalConfig }) => {
  const { isDark, toggleTheme } = useTheme();
  const portalColor = portalConfig?.color || '#418b4c';
  const portalName = portalConfig?.name || 'Portal';

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 h-16 px-4 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex items-center justify-between h-full max-w-screen-2xl mx-auto">
        {/* Left: Menu toggle and Logo */}
        <div className="flex items-center gap-3">
          <Button 
            variant="ghost" 
            size="icon" 
            onClick={toggleSidebar}
            className="md:hidden"
          >
            <Menu className="h-5 w-5" />
            <span className="sr-only">Toggle menu</span>
          </Button>
          
          <a href="/" className="flex items-center">
            <img
              className="h-10 w-auto"
              src="/PURElims_logo_approved_Nov2024.png"
              alt="PURELims AI Logo"
            />
          </a>
        </div>

        {/* Center: Portal indicator */}
        <div className="absolute left-1/2 transform -translate-x-1/2 hidden sm:block">
          <Badge 
            variant="outline" 
            className="px-3 py-1 text-sm font-medium border-2"
            style={{ 
              borderColor: portalColor, 
              color: portalColor,
              backgroundColor: `${portalColor}10`
            }}
          >
            {portalName} Portal
          </Badge>
        </div>

        {/* Right: Theme toggle and Logout button */}
        <div className="flex items-center gap-2">
          {/* Mobile portal badge */}
          <Badge 
            variant="outline" 
            className="px-2 py-0.5 text-xs font-medium sm:hidden"
            style={{ 
              borderColor: portalColor, 
              color: portalColor 
            }}
          >
            {portalName}
          </Badge>
          
          {/* Theme Toggle */}
          <Button 
            variant="ghost" 
            size="icon"
            onClick={toggleTheme}
            className="text-muted-foreground hover:text-foreground"
            aria-label="Toggle theme"
          >
            {isDark ? (
              <Sun className="h-4 w-4" />
            ) : (
              <Moon className="h-4 w-4" />
            )}
          </Button>
          
          <Button 
            variant="ghost" 
            onClick={onLogout}
            className="text-muted-foreground hover:text-foreground"
          >
            <LogOut className="h-4 w-4 mr-2" />
            <span className="hidden sm:inline">Logout</span>
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
